/* Elegancecoque - pastilles de couleur des cartes produits.
   30-10 (v2) :
   - au chargement, la pastille correspondant à la photo affichée est sélectionnée (contour doré) et son nom affiché ;
   - au clic : photo, texte alternatif, nom de la couleur et liens de la carte changent immédiatement ;
   - le lien pointe vers la variante exacte couleur + modèle d'iPhone mémorisé (data-vars) ;
   - si un autre script remet la photo d'origine (filtre « Quel est votre iPhone ? », retour arrière),
     la couleur choisie par la cliente est conservée : la photo et les liens de cette couleur sont réappliqués ;
   - chaque carte est indépendante (aucune sélection ne touche une autre carte). */
(function(){
if(window.__luxeSw){return;}window.__luxeSw=true;
var d=document,W=window;
var CARD='[data-lcard],[data-ec-card],[data-emrq-card],[data-elux-card],[data-ecat-card],[data-esil-card],[data-lcat-card],[data-lau-card],[data-ecx-card],.lcard,.ec-p,.lau__card,.ecx-card,.lwl-card';
var LINKS='a.lcard__media,a.lcard__name,a.ec-p__media,a.ec-p__name,a[data-emrq-link],a[data-elux-link],a[data-ecat-link],a[data-esil-link],a[data-lcat-link],a[data-lau-link],a[data-ecx-link]';
var IMG='.lcard__media img,.ec-p__media img,.lau__media img,.ecx-card__media img';
function qa(r,s){return [].slice.call(r.querySelectorAll(s));}
function cardOf(el){return el.closest(CARD)||el.closest('li');}
function imgOf(card){return card?(card.querySelector(IMG)||card.querySelector('a[href*="/products/"] img')||card.querySelector('img')):null;}
function base(u){return String(u||'').split('?')[0].split('/').pop().replace(/_(\d+x\d*|\d*x\d+)(?=\.)/,'').toLowerCase();}
function vh(v){return 'iphone-'+String(v||'').toLowerCase().trim().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');}
function model(){
  try{if(W.ECModel){var m=W.ECModel.read();if(m&&m.handle){return m.handle;}}}catch(e){}
  try{return (W.localStorage.getItem('ec-model')||'').split('|')[0];}catch(e){return '';}
}
function hrefFor(b){
  var h=b.getAttribute('data-href')||'',vars=b.getAttribute('data-vars')||'',m=model();
  if(m&&vars){
    var hit=vars.split('|').map(function(s){return s.split('=');}).filter(function(p){return p[1]&&vh(p[0]).replace(/-(normal|standard)$/,'')===m;})[0];
    if(hit){return h.split('?')[0]+'?variant='+hit[1];}
  }
  return h;
}
function setImg(img,src,alt){
  if(!img||!src){return;}
  img.__swSrc=src;
  img.removeAttribute('srcset');
  img.setAttribute('src',src);
  if(alt){img.setAttribute('alt',alt);}
}
function show(b,applyImg){
  var box=b.closest('.lsw'),card=cardOf(b);if(!box){return;}
  qa(box,'.lsw__b').forEach(function(x){x.setAttribute('aria-pressed',x===b?'true':'false');});
  var nm=box.querySelector('.lsw__name');if(nm){nm.textContent=b.getAttribute('data-name')||'';}
  if(!card){return;}
  var href=hrefFor(b);
  if(href){qa(card,LINKS).forEach(function(a){a.setAttribute('href',href);});}
  if(applyImg){
    var img=imgOf(card),src=b.getAttribute('data-img');
    if(img&&src){
      if(!img.__o){img.__o=[img.getAttribute('src'),img.getAttribute('srcset')||'',img.getAttribute('alt')||''];}
      var t=(card.querySelector('.lcard__name,.ec-p__name')||{}).textContent||'';
      setImg(img,src,(t.trim()?t.trim()+', ':'')+(b.getAttribute('data-name')||''));
    }
  }
}
/* sélection initiale : la pastille dont la photo est affichée */
function init(box){
  if(box.__sw){return;}box.__sw=true;
  var bs=qa(box,'.lsw__b');if(!bs.length||box.querySelector('.lsw__b[aria-pressed="true"]')){return;}
  var card=cardOf(box),img=imgOf(card),hit=null;
  if(img){
    var alt=(img.getAttribute('alt')||'').toLowerCase(),cur=base(img.getAttribute('src'));
    hit=bs.filter(function(b){return base(b.getAttribute('data-img'))===cur;})[0]||null;
    if(!hit){hit=bs.filter(function(b){var n=(b.getAttribute('data-name')||'').toLowerCase();return n&&(alt.indexOf(', '+n+' ')>-1||alt.indexOf(', '+n+' –')>-1||alt.slice(-n.length-2)===', '+n);})[0]||null;}
  }
  if(!hit&&bs.length===1){hit=bs[0];}
  if(hit){show(hit,false);}
}
function initAll(){qa(d,'.lsw').forEach(init);}
d.addEventListener('click',function(e){
  var b=e.target.closest&&e.target.closest('.lsw__b');if(!b){return;}
  e.preventDefault();
  show(b,true);
},true);
/* un autre script a changé la photo de la carte : on garde la couleur choisie */
function onSrc(img){
  var s=img.getAttribute('src');if(!s||s===img.__swSrc){return;}
  var card=cardOf(img);if(!card){return;}
  var b=card.querySelector('.lsw__b[aria-pressed="true"]');if(!b){return;}
  var want=b.getAttribute('data-img');
  if(want&&base(want)!==base(s)){W.setTimeout(function(){show(b,true);},0);}
  else{W.setTimeout(function(){var href=hrefFor(b);if(href){qa(card,LINKS).forEach(function(a){a.setAttribute('href',href);});}},0);}
}
function boot(){
  initAll();
  if(!W.MutationObserver){return;}
  var t=0;
  new MutationObserver(function(ms){
    var add=false;
    ms.forEach(function(m){
      if(m.type==='attributes'&&m.target.tagName==='IMG'){onSrc(m.target);}
      else if(m.type==='childList'&&m.addedNodes.length){add=true;}
    });
    if(add){W.clearTimeout(t);t=W.setTimeout(initAll,80);}
  }).observe(d.body,{subtree:true,childList:true,attributes:true,attributeFilter:['src']});
}
if(d.readyState==='loading'){d.addEventListener('DOMContentLoaded',boot);}else{boot();}
W.addEventListener('pageshow',function(e){if(e.persisted){qa(d,'.lsw__b[aria-pressed="true"]').forEach(function(b){show(b,true);});}});
W.LuxeSwatches={init:initAll};
})();
